import React, { useEffect, useState } from 'react'
import config from "../../config/config.json";
import axios from 'axios';

const AssignedCourse = () => {
    const { API_BASE_URL, WEB_BASE_URL } = config;

    //  default empty array
    const [AssignedCourse, setAssignedCourse] = useState([]);

    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const userSession = JSON.parse(localStorage.getItem('user'));

        if (userSession && userSession.uuid) {
            const userId = userSession.uuid;

            if (userId) {
                getAssignCourse(userId);
            }

            setUserId(userId);
        } else {
            console.error("localstorage data");
        }

    }, []);

    const getAssignCourse = async (userId) => {
        try {
            const response = await axios.post(
                `${API_BASE_URL}/Courses/GetAssignedCourses`,
                {
                    userid: userId
                }
            );

            console.log(response.data);
            setAssignedCourse(response.data || []);

        } catch (error) {
            console.log("error", error);
            setAssignedCourse([]); 
        }
    }

    const gotoCourse = () => {
        const userSession = JSON.parse(localStorage.getItem('user'));

        if (userSession && userSession.token) {
            const token = userSession.token;
            const url = `${WEB_BASE_URL}?token=${token}`;
            window.open(url, "_blank");
        } else {
            console.error("issue of go to learn dashboard");
        }
    }

    return (
        <>
            <h1 className='text-3xl pt-5 pb-5 font-bold'>Course</h1>
            {AssignedCourse.length === 0 ? (
                <div className="text-center text-gray-500 text-xl mt-10">
                    Course not assigned
                </div>
            ) : (
                <div className='grid md:grid-cols-1 sm:grid-cols-1 lg:grid-cols-2'>

                    {AssignedCourse.map((item, index) => (
                        <a
                            key={index}
                            href="#"
                            className="flex mb-16 flex-col items-center bg-white border border-gray-200 rounded-lg shadow md:max-w-[30vw] hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700"
                        >
                            <img
                                className="object-cover w-full rounded-t-lg h-96 md:h-[26vw] md:w-[30vw]"
                                src={`${API_BASE_URL}/${item?.courseThumbnail}`}
                                alt=""
                            />

                            <div className="flex flex-col justify-between p-4 leading-normal">
                                <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                                    {item?.courseName}
                                </h5>

                                <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
                                    {item?.courseDescription}
                                </p>

                                <button
                                    onClick={gotoCourse}
                                    className='p-2 rounded-xl border-blue-700 border-[1px] text-[1.4vw] font-bold hover:bg-blue-800 transition'
                                >
                                    Join Now
                                </button>
                            </div>
                        </a>
                    ))}

                </div>
            )}
        </>
    )
}

export default AssignedCourse;